<template>
    <div v-if="visible" :style="loaderSnappingStyle">
        <div
            :class="{
                'mds-loader--small': size === 'small',
                'mds-loader--medium': size === 'medium',
                'mds-loader--large': size === 'large',
            }"
            :aria-hidden="!visible"
            :aria-valuetext="text"
            class="mds-loader"
            role="progressbar"
        >
            <div class="mds-loader__item mds-loader__item--1"></div>
            <div class="mds-loader__item mds-loader__item--2"></div>
            <div class="mds-loader__item mds-loader__item--3"></div>
            <div class="mds-loader__item mds-loader__item--4"></div>
            <div class="mds-loader__item mds-loader__item--5"></div>
            <div class="mds-loader__item mds-loader__item--6"></div>
            <div class="mds-loader__item mds-loader__item--7"></div>
            <div class="mds-loader__item mds-loader__item--8"></div>
        </div>
    </div>
</template>

<script>
import mdsConstants from 'morningstar-design-system/constants/constants.json';

export default {
    name: 'spin-loader',
    props: {
        visible: {
            type: Boolean,
            default: false,
        },
        text: {
            type: String,
            default: 'Loading'
        },
        size: {
            type: String,
            default: 'medium',
            validator(size) {
                return ['small', 'medium', 'large'].some(allowedSize => allowedSize === size);
            }
        },
        snapping: {
            type: Boolean,
            default: true,
            validator(snapping) {
                return typeof snapping === 'boolean';
            }
        }
    },
    data() {
        return {
            hasChangedParentPositionStyle: false,
        };
    },
    computed: {
        loaderSnappingStyle() {
            return this.snapping ? this.$options.constants.snappingStyle : {};
        }
    },
    mounted() {
        this.snapLoader();
    },
    destroyed() {
        this.restoreLoaderParentStyle();
    },
    methods: {
        snapLoader() {
            if (!this.snapping) {
                return;
            }
            // change direct parent's position style so that
            // loader can cover the entire area of parent element
            const originalParentPositionStyle = window.getComputedStyle(this.$el.parentElement).position;
            if (originalParentPositionStyle === 'static') {
                this.$el.parentElement.style.position = 'relative';
                this.hasChangedParentPositionStyle = true;
            }
        },
        restoreLoaderParentStyle() {
            // restore the parent position style back to its original
            if (this.hasChangedParentPositionStyle && this.$el.parentElement) {
                this.$el.parentElement.style.position = 'static';
                this.hasChangedParentPositionStyle = false;
            }
        }
    },
    constants: {
        snappingStyle: {
            position: 'absolute',
            width: '100%',
            height: '100%',
            top: 0,
            left: 0,
            display: 'flex',
            alignItems: 'center',
            backgroundColor: 'white',
            zIndex: mdsConstants.mds_constants['z-index']['top-of-the-world'],
        }
    }
};
</script>
